"use client";

import { useRef, useState } from "react";
import Img from "~/components/UI/Img";
import useIntersectionObserver from "~/lib/hooks/intersection-observer";
import { cn } from "~/lib/utils";

/**
 * @param {Parameters<typeof Img>[0]} props
 */
export default function BgEffectImg(props) {
  const [isVisible, setIsVisible] = useState(false);
  const imgRef = useRef(/** @type {null | HTMLImageElement} */ (null));

  // Define callback function
  /** @param {IntersectionObserverEntry[]} entries */
  const handleIntersect = (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        setIsVisible(true);
      }
    });
  };

  // Use the hook
  useIntersectionObserver(imgRef, {
    onIntersect: handleIntersect,
    options: {
      threshold: 0.5,
    }, // IntersectionObserver options
  });

  return (
    <Img
      {...props}
      ref={imgRef}
      className={cn(props.className, isVisible && "effect")}
    />
  );
}
